import React from 'react';
import newMemberEvent01 from '../../assets/images/event/new_member_event/new_member_event_01.png';
import newMemberEvent02 from '../../assets/images/event/new_member_event/new_member_event_02.png';
import newMemberEvent03 from '../../assets/images/event/new_member_event/new_member_event_03.png';
import newMemberEvent04 from '../../assets/images/event/new_member_event/new_member_event_04.png';
import newMemberEvent05 from '../../assets/images/event/new_member_event/new_member_event_05.png';

const NewMemberEventPage: React.FC = () => {
  const eventImages = [
    newMemberEvent01,
    newMemberEvent02,
    newMemberEvent03,
    newMemberEvent04,
    newMemberEvent05
  ];

  return (
    <div className="max-w-4xl mx-auto">
      {eventImages.map((imageSrc, index) => (
        <div key={index} className="flex justify-center">
                      <img
              src={imageSrc}
              alt={`신규 회원 이벤트 ${index + 1}`}
              className="max-w-full h-auto"
            />
        </div>
      ))}
    </div>
  );
};

export default NewMemberEventPage;
